import _slicedToArray from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray"; //@ts-check

import React from "react";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import request from "../../../utils/request";
import Button from "../../../core/Button";
import useProvider from "../../../core/EcrionProvider/useProvider";
import Modals from "../../../modal";
import LinkFormatter from "../../../formatter/Link";
import useLicense from "../../Licensing/useLicense";
import FragmentContainer from "./FragmentContainer";

var EmailSettingsFragment = function EmailSettingsFragment(_ref) {
  var queue = _ref.queue;

  var _useProvider = useProvider(),
      routes = _useProvider.routes;

  var history = routes && routes.history;
  var trialLicense = useLicense();

  var _React$useState = React.useState(false),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      hasBouncedEmails = _React$useState2[0],
      setHasBouncedEmails = _React$useState2[1];

  React.useEffect(function () {
    request({
      url: "/backend/emailQueueConnection/?name=".concat(queue)
    }).then(function (response) {
      return setHasBouncedEmails(response.SuspendBounce);
    });
  }, []);
  return React.createElement(FragmentContainer, {
    title: "Email"
  }, React.createElement(Typography, {
    gutterBottom: true
  }, "Configure email settings used to send out notifications."), React.createElement(Grid, {
    container: true,
    direction: "row",
    alignItems: "center",
    alignContent: "space-between",
    spacing: 1
  }, React.createElement(Grid, {
    item: true
  }, React.createElement(Button, {
    onClick: function onClick() {
      trialLicense.IsTrial === false ? history.push("/settings/email/queue/".concat(queue)) : Modals.open({
        type: Modals.TYPES.CONFIRMATION,
        props: {
          title: "Feature disabled in trial",
          message: "Email configuration feature is disabled in trial mode.",
          confirmLabel: "Close",
          hideCancel: true,
          onConfirm: function onConfirm() {}
        }
      });
    }
  }, "Configure Email")), hasBouncedEmails && React.createElement(Grid, {
    item: true
  }, React.createElement(LinkFormatter, {
    text: "View Bounced Emails",
    to: "/settings/email/bounced"
  }))));
};

EmailSettingsFragment.defaultProps = {
  queue: "Default"
};
export default EmailSettingsFragment;